import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DndModule } from 'ngx-drag-drop';
import { PopoverModule } from 'primeng/popover';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { LayoutModule } from '../Layout/layout.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { ManageSourcesDialogComponent } from './components/ManageSourcesDialog/manage-sources-dialog.component';
import { SourceApiService } from '../../api/source/source.api.service';
import { SourceGroupApiService } from '../../api/sourceGroups/source-group.api.service';
import { SourceService } from './services/source.service';
import { SourceGroupService } from './services/source-group.service';
import { SearchSourcePickerComponent } from './components/SearchSourcePicker/search-source-picker.component';
import { AddSourcesToGroupDialogComponent } from './components/AddSourcesToGroupDialog/add-sources-to-group-dialog.component';
import { SourceCreateDialogComponent } from './components/SourceCreateDialog/source-create-dialog.component';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { IncludeExcludeSourcePickerComponent } from './components/IncludeExcludeSourcePicker/include-exclude-source-picker.component';
import { TakeOverModule } from '../../Common/TakeOver/take-over.module';
import { CreateEditSourceGroupDialogComponent } from './components/CreateSourceGroupDialog/create-edit-source-group-dialog.component';
import { CreateSourceInputComponent } from './components/CreateSourceInput/create-source-input.component';
import { EditSourceDialogComponent } from './components/EditSourceDialog/edit-source-dialog.component';
import { SaveAsGroupDialogComponent } from './components/SaveAsGroupDialog/save-as-group-dialog.component';
import { SourceGroupChipComponent } from './components/SourceGroupChip/source-group-chip.component';

export const sourcesModuleImports = [
    LocalizationModule,
    CommonModule,
    FormsModule,
    CoreDialogsModule,
    CommonFormsModule,
    AutoCompleteModule,
    MessageModule,
    TooltipModule,
    MiscModule,
    LayoutModule,
    CommonBasicModule,
    TakeOverModule,
    DndModule,
    PopoverModule,
    ScrollingModule
];

export const sourcesModuleDeclarations = [
    ManageSourcesDialogComponent,
    SearchSourcePickerComponent,
    AddSourcesToGroupDialogComponent,
    SourceCreateDialogComponent,
    IncludeExcludeSourcePickerComponent,
    CreateEditSourceGroupDialogComponent,
    CreateSourceInputComponent,
    EditSourceDialogComponent,
    SaveAsGroupDialogComponent,
    SourceGroupChipComponent
];

@NgModule({
    imports: sourcesModuleImports,
    declarations: sourcesModuleDeclarations,
    exports: [
        ManageSourcesDialogComponent,
        SearchSourcePickerComponent,
        AddSourcesToGroupDialogComponent,
        SourceCreateDialogComponent,
        IncludeExcludeSourcePickerComponent,
        CreateEditSourceGroupDialogComponent,
        CreateSourceInputComponent,
        EditSourceDialogComponent,
        SaveAsGroupDialogComponent,
        SourceGroupChipComponent
    ],
    providers: [
        SourceApiService,
        SourceGroupApiService,
        SourceGroupService,
        SourceService,
    ]
})
export class SourcesModule { }
